import { Button, useDeviceType } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';

export interface ICommunicationActionButtonProps {
  onClick: () => void;
  children: React.ReactText | React.ReactText[];
  theme?: TButtonTheme;
  loading?: boolean;
  disabled?: boolean;
  testId?: string;
}

export const CommunicationActionButton: React.FC<ICommunicationActionButtonProps> = ({
  testId = 'communication-action',
  theme = 'fill_primary',
  ...props
}) => {
  const isFullWidth = useDeviceType() !== 'desktop';

  return <Button {...props} data-testid={testId} theme={theme} size="M" fullWidth={isFullWidth} />;
};

CommunicationActionButton.displayName = 'CommunicationActionButton';
